<template>
  <v-dialog
    v-model="dialog"
    max-width="900"
    persistent
    @after-leave="onAfterLeave"
  >
    <v-card class="pa-4">
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="text-h6">{{ modalTitle }}</span>

        <v-btn icon variant="text" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="cool-card">
        <v-form ref="form" v-model="isValid">
          <!-- DATOS GENERALES -->
          <h3 class="text-h6 mb-4">{{ $t("project_data") }}</h3>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('project_name')"
                v-model="formData.nombreProyecto"
                :rules="[rules.required]"
                required
                prepend-inner-icon="mdi-folder"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('project_key')"
                v-model="claveProyectoUpper"
                :rules="[rules.required, rules.projectKey]"
                prepend-inner-icon="mdi-key"
                :placeholder="$t('project_key_placeholder')"
                :disabled="mode === 'edit'"
                required
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-select
                :label="$t('business_unit')"
                v-model="formData.unidadNegocio"
                :items="unitOptions"
                :loading="loadingUnits"
                :disabled="loadingUnits"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-domain"
                item-title="title"
                item-value="value"
                required
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                :label="$t('project_type')"
                v-model="formData.tipoProyecto"
                :items="['QA', 'Manual']"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-tag"
                required
              />
            </v-col>
          </v-row>

          <v-divider class="my-6" />

          <!-- CONFIGURACIÓN -->
          <h3 class="text-h6 mb-4">{{ $t("configuration") }}</h3>

          <v-row>
            <v-col cols="12" md="4">
              <v-select
                :label="$t('status')"
                v-model="formData.estado"
                :items="['Nuevo', 'En curso', 'Mantenimiento']"
                required
                :disabled="mode === 'create'"
              >
                <template #prepend-inner>
                  <v-icon color="blue">mdi-check-circle</v-icon>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                :label="$t('responsible')"
                v-model="formData.responsable"
                :items="responsableName"
                :loading="loadingResponsable"
                :disabled="loadingResponsable"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-account"
                item-title="title"
                item-value="value"
                required
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                :label="$t('environment')"
                v-model="formData.ambiente"
                :items="['DEV', 'QA', 'UAT', 'PROD']"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-server"
                required
              />
            </v-col>
            <v-col>
              <v-textarea
                :label="$t('project_description')"
                v-model="formData.descripcion"
                prepend-inner-icon="mdi-text-box"
                auto-grow
                rows="3"
                counter="400"
                :rules="[rules.required, rules.min100]"
                required
              />
            </v-col>
          </v-row>

          <v-divider class="my-6" />

          <!-- INTEGRACIONES -->
          <div class="d-flex align-center justify-space-between mb-2">
            <h3 class="text-h6">{{ $t("integrations") }}</h3>

            <v-switch
              v-model="jiraEnabled"
              label="Jira"
              color="success"
              inset
              hide-details
            />
          </div>

          <p class="text-body-2 text-medium-emphasis mb-4">
            {{ $t("jira_description") }}
          </p>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('jira_email')"
                v-model="formData.jiraEmail"
                prepend-inner-icon="mdi-email"
                autocomplete="off"
                :disabled="!jiraEnabled"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('jira_token')"
                v-model="formData.jiraToken"
                prepend-inner-icon="mdi-key-variant"
                type="password"
                autocomplete="new-password"
                :disabled="!jiraEnabled"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('jira_domain')"
                v-model="formData.jiraDomain"
                prepend-inner-icon="mdi-domain"
                type="text"
                autocomplete="new-password"
                :disabled="!jiraEnabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :label="$t('jira_project')"
                v-model="formData.jiraproyect"
                :items="projectsJira"
                item-text="test"
                item-value="test"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-server"
                :disabled="!jiraEnabled"
              />
            </v-col>
          </v-row>
          <div class="d-flex align-center justify-space-between mb-2">
            <h3 class="text-h6">{{ $t("integrations") }}</h3>
            <v-switch
              v-model="xrayEnabled"
              label="xray"
              color="success"
              inset
              hide-details
            />
          </div>

          <p class="text-body-2 text-medium-emphasis mb-4">
            {{ $t("xray_description") }}
          </p>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('xray_client')"
                v-model="formData.xrayclient"
                prepend-inner-icon="mdi-account"
                autocomplete="off"
                :disabled="!xrayEnabled"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('xray_secret')"
                v-model="formData.xraysecret"
                prepend-inner-icon="mdi-key-variant"
                type="password"
                autocomplete="new-password"
                :disabled="!xrayEnabled"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-end">
        <v-btn
          variant="tonal"
          color="secondary"
          size="large"
          rounded="x1"
          @click="close"
          >{{ $t("cancel") }}</v-btn
        >

        <v-btn
          variant="elevated"
          color="primary"
          size="large"
          rounded="x1"
          :disabled="!isValid"
          @click="save"
        >
          {{ saveBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import "@/css/Proyectos/StyleTableNewProyect.css";
import "@/css/Proyectos/StyleTableProyect.css";
import { swal } from "@/utils/swal";
import { getJiraProyectsAll } from "@/api/jiraproyectos";
import debounce from "lodash/debounce";
import { useSettingsStore } from "@/stores/settings";
import {
  getUnitBussines,
  getResponsables,
  createProyecto,
  patchProyecto,
} from "@/api/proyectos.js";
import { getMe } from "@/api/profile.js";

export default {
  name: "NuevoProyecto",
  props: {
    modelValue: { type: Boolean, default: false },
    mode: { type: String, default: "create" },
    project: { type: Object, default: null },
  },
  emits: ["update:modelValue", "save"],

  data() {
    return {
      projectsJira: [],
      isValid: false,
      jiraEnabled: false,
      xrayEnabled: false,
      unitOptions: [],
      responsableName: [],
      loadingUnits: false,
      loadingResponsable: false,
      formData: this.getEmptyForm(),
      rules: {
        required: (v) => !!v || this.$t("field_required"),
        min3: (v) => (v && v.length >= 3) || this.$t("min_3_chars"),
        min100: (v) => (v && v.length >= 50) || this.$t("min_50_chars"),
        email: (v) => /.+@.+\..+/.test(v) || this.$t("invalid_email"),
        projectKey: (v) =>
          /^[A-Za-z]{4}-\d{3}$/.test(v) || this.$t("project_key_format"),
      },
    };
  },

  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },
    claveProyectoUpper: {
      get() {
        return this.formData.claveProyecto;
      },
      set(val) {
        this.formData.claveProyecto = val.toUpperCase();
      },
    },
    dialog: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
    modalTitle() {
      return this.mode === "edit"
        ? this.$t("edit_project")
        : this.$t("new_project");
    },
    saveBtnText() {
      return this.mode === "edit"
        ? this.$t("save_changes")
        : this.$t("save_project");
    },
  },

  watch: {
    "formData.jiraDomain": "checkLoadProjects",
    "formData.jiraEmail": "checkLoadProjects",
    "formData.jiraToken": "checkLoadProjects",
    async modelValue(val) {
      if (val) {
        await this.fetchUnits();
        await this.fetchResponsable();
        await this.$nextTick();

        this.loadProject();

        this.$nextTick(() => this.$refs.form?.resetValidation?.());
      } else {
        requestAnimationFrame(() => {
          if (this.mode === "create") this.reset();
          else this.$refs.form?.resetValidation?.();
        });
      }
    },
    project: {
      deep: true,
      async handler() {
        if (!this.modelValue) return;
        if (this.mode !== "edit") return;
        if (!this.project) return;

        if (!this.unitOptions.length && !this.loadingUnits) {
          await this.fetchUnits();
          await this.fetchResponsable();
        }

        await this.$nextTick();
        this.loadProject();
      },
    },
  },
  methods: {
    resolveUnitValue(unit) {
      if (unit === null || unit === undefined || unit === "") return "";

      const n = Number(unit);
      if (!Number.isNaN(n)) return n;

      const found = (this.unitOptions || []).find(
        (u) =>
          (u.title || "").toString().toLowerCase() ===
          unit.toString().toLowerCase(),
      );
      return found ? found.value : "";
    },
    checkLoadProjects: debounce(function () {
      const { jiraDomain, jiraEmail, jiraToken } = this.formData;

      if (jiraDomain && jiraEmail && jiraToken) {
        this.loadProyectsJira(jiraDomain, jiraEmail, jiraToken);
      } else {
        this.projectsJira = [];
        this.formData.jiraproyect = "";
      }
    }, 300), // espera 300ms para que el usuario termine de escribir

    getEmptyForm() {
      return {
        originalKey: null,
        nombreProyecto: "",
        claveProyecto: "",
        unidadNegocio: "",
        tipoProyecto: "",
        estado: "Nuevo",
        responsable: "",
        ambiente: "",
        descripcion: "",
        chatgpt: false,
        jiraproyect: "",
        jiraEmail: "",
        jiraToken: "",
        jiraDomain: "",
        xrayClient: "",
        xraySecret: "",
        xrayclient: "",
        xraysecret: "",
      };
    },
    async loadProyectsJira(domain, jiraEmail, jiraToken) {
      console.log("www", domain, jiraEmail, jiraToken);
      const respuesta = await getJiraProyectsAll(domain, jiraEmail, jiraToken);
      if (respuesta.length > 0) {
        this.projectsJira = respuesta.map((p) => p.key);
      } else {
        this.projectsJira = [];
        console.log("error en los datos de jira");
      }
    },
    loadProject() {
      if (this.mode !== "edit" || !this.project) return;

      const p = this.project;

      const idProyect = p.idProyect ?? p.clave ?? null;
      const nameProyect = p.nameProyect ?? p.nombre ?? "";
      const unitRaw = p.UnitBussines ?? p.unidadNegocio ?? p.unitBussines ?? "";
      const unitVal = this.resolveUnitValue(unitRaw);
      const typeProject = p.typeProject ?? p.tipo ?? "";
      const status = p.status ?? p.estado ?? "Nuevo";
      const accountable = p.accountable ?? p.qaLead ?? "";
      const environ = p.environ ?? p.ambiente ?? "";
      const description = p.description ?? p.descripcion ?? "";

      this.formData = {
        ...this.getEmptyForm(),
        originalKey: idProyect,
        nombreProyecto: nameProyect,
        claveProyecto: idProyect ?? "",
        unidadNegocio: unitVal,
        tipoProyecto: typeProject,
        estado: status,
        responsable: accountable,
        ambiente: environ,
        descripcion: description,
        jiraEmail: p.jira?.email ?? p.jiraemail ?? "",
        chatgpt: !!(p.chatgpt ?? false),
        jiraproyect: p.jiraproyect ?? "",
        jiraToken: p.jira?.token ?? p.jiratoken ?? "",
        jiraDomain: p.jira?.dominio ?? p.jiradominio ?? "",
        xraysecret: p.xraySecret ?? "",
        xrayclient: p.xrayClient,
      };

      this.jiraEnabled = !!(
        this.formData.jiraEmail ||
        this.formData.jiraToken ||
        this.formData.jiraproyect
      );
      this.xrayEnabled = !!(
        this.formData.xrayclient || this.formData.xraysecret
      );
      console.log("5555 ", this.jiraEnabled, "DDDd ", this.xrayEnabled);
      this.$nextTick(() => this.$refs.form?.resetValidation?.());
    },

    reset() {
      this.formData = this.getEmptyForm();
      this.jiraEnabled = false;
      this.xrayEnabled = false;
      this.isValid = false;
      this.$refs.form?.resetValidation?.();
    },
    onAfterLeave() {
      this.$refs.form?.resetValidation?.();
      this.isValid = false;

      if (this.mode === "create") {
        this.formData = this.getEmptyForm();
        this.jiraEnabled = false;
        this.xrayEnabled = false;
      }
    },
    close() {
      this.$emit("update:modelValue", false);
    },

    extraerUnidadId(me){
      if (!me) return null;
      const raw= 
      me.unidad ?? me.unit ?? me.UnitBussines ?? me.unidadNegocio ?? me.business_unit ?? me.unit_id ?? null;
      if (raw == null) return null;
      if(typeof raw === "object") return raw.id ?? raw.value ?? null;
      return raw;
    },
    async fetchUnits() {
      this.loadingUnits = true;
      try {
        //const data = await getUnitBussines();
        const [data, me]= await Promise.all([getUnitBussines(), getMe()]);
        console.log("Me (usuario actual)", me);
        const miUnidadId=this.extraerUnidadId(me);
        let opciones = (data || []).map((u) => ({
          title: u.nameUnitBussines,
          value: Number(u.id),
        }));

        // El admin puede elegir cualquier unidad. Los demas quedan restringidos
        // a la unidad de negocio a la que estan asignados.
        const isAdmin = localStorage.getItem("role") === "Admin QA";
        if (!isAdmin && miUnidadId != null) {
          opciones = opciones.filter((o) => o.value === Number(miUnidadId));
        }
        this.unitOptions = opciones;

        // Si queda una sola opcion (no admin), preseleccionarla al crear.
        if (
          !isAdmin &&
          this.mode === "create" &&
          this.unitOptions.length === 1
        ) {
          this.formData.unidadNegocio = this.unitOptions[0].value;
        }
      } catch {
        this.unitOptions = [];
       await swal({
          icon: "error",
          title: "Error",
          text: this.$t("swaltext3"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } finally {
        this.loadingUnits = false;
      }
    },
    async fetchResponsable() {
      this.loadingResponsable = true;
      try {
        const data = await getResponsables();
        this.responsableName = (data || []).map((u) => ({
          title: u.username,
          value: Number(u.id),
        }));
      } catch {
        this.responsableName = [];
       await swal({
          icon: "error",
          title: "Error",
          text: this.$t("swaltext4"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } finally {
        this.loadingResponsable = false;
      }
    },

    async save() {
      let valid = true;
      if (this.$refs.form?.validate) {
        const res = await this.$refs.form.validate();
        valid = typeof res === "boolean" ? res : !!res?.valid;
      }
      if (!valid) return;

      const isEdit = this.mode === "edit";

      const keyToUse = isEdit
        ? (this.formData.originalKey || "").trim()
        : (this.formData.claveProyecto || "").trim();

      if (!keyToUse) {
       await swal({
          icon: "warning",
          title: this.$t("missing_key_title"),
          text: this.$t("missing_key_text"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
        return;
      }

      if (keyToUse.length > 8) {
       await swal({
          icon: "warning",
          title: this.$t("invalid_key_title"),
          text: this.$t("invalid_key_text"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
        return;
      }

      const payload = {
        idProyect: keyToUse,
        nameProyect: (this.formData.nombreProyecto || "").trim(),
        typeProject: (this.formData.tipoProyecto || "").trim(),
        status: this.formData.estado || "Nuevo",
        accountable: this.formData.responsable,
        environ: (this.formData.ambiente || "").trim(),
        description: (this.formData.descripcion || "").trim(),
        chatgpt: false,

        jiraproyect: this.jiraEnabled
          ? (this.formData.jiraproyect || "").trim()
          : null,
        jiraemail: this.jiraEnabled
          ? (this.formData.jiraEmail || "").trim()
          : null,
        jiratoken: this.jiraEnabled
          ? (this.formData.jiraToken || "").trim()
          : null,
        jiradominio: this.jiraEnabled
          ? (this.formData.jiraDomain || "").trim()
          : null,

        xrayClient: this.xrayEnabled
          ? (this.formData.xrayclient || "").trim()
          : null,
        xraySecret: this.xrayEnabled
          ? (this.formData.xraysecret || "").trim()
          : null,

        UnitBussines: this.formData.unidadNegocio,
      };
      console.log("WERTT", payload);
      try {
        const saved = isEdit
          ? await patchProyecto(keyToUse, payload)
          : await createProyecto(payload);

        this.$emit("save", saved);
        this.close();

        const projectName = (
          saved?.nameProyect ||
          this.formData.nombreProyecto ||
          ""
        ).trim();
        const projectKey = (saved?.idProyect || keyToUse || "").trim();

        const title = isEdit
          ? this.$t("project_updated")
          : this.$t("project_created");

        const text = projectKey
          ? this.$t(
              isEdit
                ? "project_updated_detail_key"
                : "project_created_detail_key",
              {
                name: projectName,
                key: projectKey,
              },
            )
          : this.$t(
              isEdit ? "project_updated_detail" : "project_created_detail",
              {
                name: projectName,
              },
            );

        await swal({
          icon: "success",
          title,
          text,
          timer: 2500,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } catch (e) {
        this.close();
        const err = e?.response?.data || {};
       await swal({
          icon: "error",
          title: this.$t("error"),
          text: err?.error || err?.detail || this.$t("project_save_error"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      }
    },
  },
};
</script>
